import {Dayjs} from "dayjs";
import {ThemeName} from "@memaro/themes";

export enum Plan {
    Trial = 'trial',
    Bronze = 'bronze',
    Silver = 'silver'
}

export type ListProfilesEntry = {
    id: string
    name: string
    profilePicture: string
}

export type ListProfilesOutput = {
    profiles: ListProfilesEntry[]
}

export type GetProfileOutput = SaveProfileInput & {
    id: string
    isPublic: boolean
    isBlocked: boolean
    plan: Plan
}

export type SaveProfileInput = {
    etag?: string
    name: string | undefined
    dateOfBirth: Dayjs | undefined
    dateOfDeath: Dayjs | undefined
    profilePicture: string | undefined
    theme: ThemeName | undefined
    sections: Section[] | undefined
}

type BaseSection = {
    isPublic: boolean
}

export type TextSection = BaseSection & {
    type: "text"
    text: string
}

export type PhotoCarouselSection = BaseSection & {
    type: "photo_carousel"
    photos: string[]
}

export type VideoSection = BaseSection & {
    type: "video"
    video?: string
}

export type AudioSection = BaseSection & {
    type: "audio"
    src?: string
}

export type Section = TextSection | PhotoCarouselSection | VideoSection | AudioSection

export type GetGroupsOutput = {
    groupIDs?: string[]
}

export type ListGroupMembershipOutput = {
    groupMemberships: GroupMembership[]
}

export type GroupMembership = {
    username: string
    groupIDs: string[]
}

export type ResignFileOutput = {
    assetURL: string
}


export type UploadType = "profile_picture" | "carousel" | "video" | "audio"

export type UploadOutput = {
    files: UploadOutputFile[]
}

export type UploadOutputFile = {
    jobID: string
    fileName: string
    uploadURL: string
    uploadHeaders: {
        [key: string]: string
    }
}

export type Job = {
    id: string
    status: 'pending' | 'succeeded' | 'failed'
    error?: string
    assetURL?: string
}

export type CreateProfileOutput = {
    id: string
}

export type GetQRCodeResponse = {
    status: string
    url: string
}

export type InitiatePaymentInput = {
    plan: Plan
    yearsUpfront: number
}

export type InitiatePaymentOutput = {
    url: string
}

export type RegisterPartnerInput = {
    email: string
    companyName: string
    kvkNumber: string
}

export type InviteUserInput = {
    email: string
}

export type PromoOrderInput = {
    street: string
    houseNumber: string
    houseNumberAddition: string | undefined
    postalCode: string
    city: string
}
